import { Component, OnDestroy } from '@angular/core';
import { BookingFormActionType } from '../../bookings/booking-form/shared/booking-form-action-type';
import { IBookingFormCallBackData } from '../../bookings/booking-form/booking-form-summary/booking-form-summary.page';
import { Booking } from '../../models/booking/booking.model';
import { UserService } from '../../services/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { TimeSlotEvent } from '../../bookings/calendar/day-view-calendar/day-view-calendar.component';
import { NavigationStateService } from '../../services/navigation-state.service';
@Component({
  selector: 'app-waitlist-calendar',
  templateUrl: './waitlist-calendar.page.html',
  styleUrls: ['./waitlist-calendar.page.scss'],
})
export class WaitlistCalendarPage implements OnDestroy {

  private booking: Booking;

  public stylistID: number;

  public readOnlyStylistPicker: boolean;

  public promise: Function;

  public navigationStateSubscription;

  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
    private router: Router,
    private navigationStateService: NavigationStateService
  ) {

    this.navigationStateSubscription = this.navigationStateService.getState().subscribe((state) => {
      this.booking = state.booking;
    });

    this.readOnlyStylistPicker = true;
    if (this.userService.isLoggedIn()) {
      const user = this.userService.getUser();
      if (user.isAdministrator() || user.getViewAllCalendars() === 1) {
        this.readOnlyStylistPicker = false;
      } else {
        this.readOnlyStylistPicker = true;
      }

      this.stylistID = user.getID();
    }

    /*this.promise = this.navParams.get('promise')
    /  ? this.navParams.get('promise')
      : function () {}; */

      this.promise = route.snapshot.params.promise ? route.snapshot.params.promise: function () {};
  }
  
  public ngOnDestroy() {
    this.navigationStateSubscription.unsubscribe();
  }

  public onTimeSelected(timeslot: TimeSlotEvent) {
    this.booking = this.booking.setStartDateTime(timeslot.date);
    this.booking = this.booking.setStatus(3);
    //this.booking = this.booking.removeServices();

    new Promise((resolve, reject) => {
      // change navigation from Services Page(BookingFormServiceDefinitionListPage) to Booking Form Summary Page,when booking through waitlist
      this.navigationStateService.setState({
        booking: this.booking,
        actionType: BookingFormActionType.AddFirstServiceToWaitListBooking,
      });
      this.router.navigate(["./bookings/booking-form-summary/0"]);
    }).then((callBackData: IBookingFormCallBackData) => {
      this.promise(callBackData);
    });
  }

}
